(function PackageSearchResults($, Adzuki)
{
	"use strict";
	$(document).ready(function documentReady()
	{
		var packageSearchPages = ['/Packages/view'];

		Adzuki.onload(packageSearchPages, function onload()
		{
			$('.category-details').click(function categoryClicked(e) {
				var $self       = $(this),
				    $content_id = $self.data("modal-id"),
				    $content    = $('#' + $content_id).html();

				e.preventDefault();

				$('.modal-title').text($self.data("name"));
				$('.modal-body').html($content);
				$('.modal').modal('show');
			});
		}, false);
	});
}(jQuery, window.Adzuki || {}));
